/**
 * Production BLE transport constants for Xprinter XP-P203A (58 mm portable).
 * Applied in WebBluetoothTransport when printerModelId === 'xp-p203a'.
 */
export const XP_P203A_BLE_CHUNK_BYTES = 14;
export const XP_P203A_BLE_INTER_CHUNK_DELAY_MS = 55;
export const XP_P203A_BLE_POST_WRITE_SETTLE_MS = 280;
export const XP_P203A_BLE_WAKE_BYTES = 16;

/** ISSC transparent UART (Printer001-*); raw ESC/POS, no wake — typical ATT payload 20 B. */
export const ISSC_BLE_CHUNK_BYTES = 20;
/** Extra per-chunk gap after each ATT write (bitbank2 ISSC reference uses ~4 ms). */
export const ISSC_BLE_INTER_CHUNK_DELAY_MS = 4;
/** Extra gap after each chunk when printer never sent [0x01, n] credits. */
export const ISSC_BLE_DELAY_ONLY_CHUNK_MS = 40;
/** Slower pacing for TSPL line chunks when ISSC credits never arrive. */
export const ISSC_BLE_DELAY_ONLY_TSPL_CHUNK_MS = 60;
/** Minimum gap between TSPL line chunks over ISSC (label parser needs whole lines). */
export const ISSC_BLE_TSPL_INTER_CHUNK_DELAY_MS = 12;
export const ISSC_BLE_POST_WRITE_SETTLE_MS = 1200;
/** Gap before/after standalone UART flush byte (0x0D) after the job. */
export const ISSC_BLE_UART_FLUSH_MS = 60;
/** After notify enable, wait before first print (bridge open time). */
export const ISSC_BLE_POST_CONNECT_MS = 400;
